Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _three = require('three');

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var icon_home = 'data:image/svg+xml;base64,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';
var icon_home_hover = 'data:image/svg+xml;base64,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';


var OrbitControls = require('react-cubeview/lib/OrbitControls')(THREE);

var renderer = void 0,
    scene = void 0,
    // windowSize = { width: 0, height: 0 },
    animation = void 0,
    controllers = void 0;
var mouse = void 0,
    raycaster = void 0,
    INTERSECTED = void 0;
// var cube = void 0;

var texture_top = 'data:image/png;base64,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';
var texture_right = 'data:image/png;base64,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';
var texture_left = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAABGZJREFUeAHtnb1KK1EUhU/MFQURRAux8yHS+VNoJYqthfgMsUjvM+QptLURfAB9BUUbC8FKtBAb0VwmkMCWYTkh15m5Wd9AMHv2yTlnrfU5ZEIgjU6n00sctg5M2SpHeN+BPwMf2u324Cl/DRzodrt9lVwBDMJWEgFAuWPQAwCDkJVEAFDuGPQAwCBkJREAlDsGPQAwCFlJBADljkEPAAxCVhIBQLlj0AMAg5CVRABQ7hj0AMAgZCURAJQ7Bj0AMAhZSQQA5Y5BDwAMQlYSAUC5Y9ADAIOQlUQAUO4Y9ADAIGQlEQCUOwY9ADAIWUkEAOWOQQ8ADEJWEgFAuWPQAwCDkJVEAFDuGPQAwCBkJREAlDsGPQAwCFlJBADljkEPAAxCVhIBQLlj0AMAg5CVRABQ7hj0AMAgZCURAJQ7Bj0AMAhZSQQA5Y5BDwAMQlYSAUC5Y9ADAIOQlUQAUO4Y9ADAIGQlEQCUOwY9ADAIWUkEAOWOQQ8ADEJWEgFAuWPQAwCDkJXE4W8GqUFl9M7OztL7+3s6OjpK09PTIy15e3ubrq+vR3pNNnhubi4dHBwMXzfYw/BEgScrKyvp6empwMj8IcvLy2l3dze/WcLZ2gBwd3eX3t7e0ufn58gAvLy8pAyCRqORpqaKX9QWFhaCxYM9NJvNcF4V2dj7+/vcIV9fX6nX68l9fXx85L62rJO1AeBfCF5bW0v7+/tjT3VycpJmZ2fHnufq6iqdn5+njY2NtLe3N/Z8vzFB8X+X31idOSt3AAAqj6DaDQBAtf5XvjoAVB5BtRsAgGr9r3x1AKg8gmo3MFG3gQ8PD+ni4qKwo1tbW7m3e5eXlz9+FpF95rCzs1N4rboOnCgAHh8fU/Yoeqyvr+cCkN2//3RkHwABwE8uldxvtVppe3u78Krz8/O5Y4+Pj9PMzExub9JOTtQVIPv0bmlpaeyMFhcXc68MY09cwwl4E1jDUMrcEgCU6XYN1wKAGoZS5pYAoEy3a7gWANQwlDK3BABlul3DtWp3G3h6epqKfiNndXU1bW5uDm29ublJr6+vw7rIk8PDw8LrFZnvfxtTOwCyEIse30F5fn5O2WOUI/vKlvPR6HQ6fQfa7bazD3bau91uXzPvAeyij4IBIPphVwGAXeRRMABEP+wqALCLPAoGgOiHXQUAdpFHwQAQ/bCrAMAu8igYAKIfdhUA2EUeBQNA9MOuAgC7yKNgAIh+2FUAYBd5FAwA0Q+7CgDsIo+CASD6YVcBgF3kUTAARD/sKgCwizwKBoDoh10FAHaRR8EAEP2wqwDALvIoGACiH3YVANhFHgUDQPTDrgIAu8ijYACIfthVAGAXeRQMANEPuwoA7CKPggEg+mFXAYBd5FEwAEQ/7CoAsIs8CgaA6IddBQB2kUfBABD9sKsAwC7yKBgAoh92FQDYRR4FA0D0w64CALvIo2AAiH7YVQBgF3kUDADRD7sKAOwij4IBIPphVw1/M2jwEyJ2DpgL5gpgDsBfeI905rJ3A+AAAAAASUVORK5CYII=';
var texture_front = 'data:image/png;base64,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';
var texture_back = 'data:image/png;base64,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';
var texture_bottom = 'data:image/png;base64,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';
var texture_shadow = 'data:image/png;base64,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';


var CubeView = function (_Component) {
    _inherits(CubeView, _Component);

    function CubeView(props) {
        _classCallCheck(this, CubeView);

        var _this2 = _possibleConstructorReturn(this, (CubeView.__proto__ || Object.getPrototypeOf(CubeView)).call(this, props));

        _this2.DEBUG = _this2.props.DEBUG ? _this2.props.DEBUG : false;
        _this2.state = {
            icon_home: icon_home
        };

        _this2.hoverHomeOn = _this2.hoverHomeOn.bind(_this2);
        _this2.hoverHomeOff = _this2.hoverHomeOff.bind(_this2);
        _this2.clickHome = _this2.clickHome.bind(_this2);
        _this2.setAngles = _this2.setAngles.bind(_this2);



        return _this2;
    }

    /*
        setAngles(phi, theta) {
            if (this.controls) {
                this.setAngles(phi, theta);

            }

        }
    */


    _createClass(CubeView, [{
        key: 'setAngles',
        value: function setAngles(phi, theta) {
            if (this.controls) {
                this.controls.setExternalControl(true);

                this.controls.setPolarAngle(phi);
                this.controls.setAzimuthalAngle(theta);

                this.controls.setExternalControl(false);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            var canvas = this.refs.threeCanvas;
            this.hoverColor = this.props.hoverColor ? this.props.hoverColor : 0x0033ff;

            if (this.props.onUpdateAngles) this.updateAngles = this.props.onUpdateAngles;

            this.init();
            this.updateDimensions();
            this.updateDimensions = this.updateDimensions.bind(this);
            window.addEventListener('resize', this.updateDimensions);

            canvas.addEventListener('mousemove', this.onMouseMove.bind(this));
            canvas.addEventListener('mousedown', this.onMouseDown.bind(this));
            canvas.addEventListener('mouseup', this.onMouseUp.bind(this));
        }
    }, {
        key: 'onMouseDown',
        value: function onMouseDown(event) {
            this.mouseMoving = false;
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(event) {
            if (this.mouseMoving === false) {
                if (INTERSECTED) {
                    //var angle = controls.getAutoRotationAngle();
                    //this.controls.rotateLeft(45);
                    //this.controls.rotateLeft(45);
                    //this.controls.setAzimuthalAngle(Math.PI);
                    //var a = this.controls.getPolarAngle();
                    this.setViewAngle(INTERSECTED.name);

                    // var xAxis = new THREE.Vector3(1,1,0);
                    //this.camera.rotateOnAxis( xAxis, 10 );

                    //this.camera.position.set(0, this.cameraDistance, 0);
                    //this.controls.update();

                    //console.log('this.controls angles', (this.controls.getPolarAngle()/ Math.PI).toFixed(4), (this.controls.getAzimuthalAngle()/ Math.PI).toFixed(4));
                }
            } else if (this.mouseMoving === true) {
            }
        }
    }, {
        key: 'setViewAngle',
        value: function setViewAngle(name) {
            var phi, theta;

            switch (name) {
                //Faces
                case 'f0':
                    //RIGHT
                    phi = Math.PI * 0.5;
                    theta = Math.PI * 0.5;
                    break;
                case 'f1':
                    //TOP
                    phi = 0;
                    theta = 0;
                    break;
                case 'f2':
                    //FRONT
                    phi = Math.PI * 0.5;
                    theta = 0;
                    break;
                case 'f3':
                    //LEFT
                    phi = Math.PI * 0.5;
                    theta = -Math.PI * 0.5;
                    break;
                case 'f4':
                    //BOTTOM
                    phi = Math.PI;
                    theta = 0;
                    break;
                case 'f5':
                    //BACK
                    phi = Math.PI * 0.5;
                    theta = Math.PI;
                    break;
                //corners
                case 'c0':
                    //FRONT,TOP,RIGHT
                    phi = Math.PI * 0.25;
                    theta = Math.PI * 0.25;
                    break;
                case 'c1':
                    //FRONT,BOTTOM, RIGHT
                    phi = Math.PI * 0.75;
                    theta = Math.PI * 0.25;
                    break;
                case 'c2':
                    //FRONT,BOTTOM,lEFT
                    phi = Math.PI * 0.75;
                    theta = -Math.PI * 0.25;
                    break;
                case 'c3':
                    //FRONT,TOP,lEFT
                    phi = Math.PI * 0.25;
                    theta = -Math.PI * 0.25;
                    break;
                case 'c4':
                    //BACK,TOP,RIGHT
                    phi = Math.PI * 0.25;
                    theta = Math.PI * 0.75;
                    break;
                case 'c5':
                    //BACK,BOTTOM,RIGHT
                    phi = Math.PI * 0.75;
                    theta = Math.PI * 0.75;
                    break;
                case 'c6':
                    //BACK,BOTTOM,LEFT
                    phi = Math.PI * 0.75;
                    theta = -Math.PI * 0.75;
                    break;
                case 'c7':
                    //BACK,TOP,LEFT
                    phi = Math.PI * 0.25;
                    theta = -Math.PI * 0.75;
                    break;
                //Edges
                case 'e0':
                    //TOP,FRONT
                    phi = Math.PI * 0.25;
                    theta = 0;
                    break;
                case 'e1':
                    //TOP,BOTTOM
                    phi = Math.PI * 0.75;
                    theta = 0;
                    break;
                case 'e2':
                    //TOP,BACK
                    phi = Math.PI * 0.25;
                    theta = Math.PI;
                    break;
                case 'e3':
                    //BOTTOM,BACK
                    phi = Math.PI * 0.75;
                    theta = Math.PI;
                    break;
                case 'e4':
                    //FRONT,RIGHT
                    phi = Math.PI * 0.5;
                    theta = Math.PI * 0.25;
                    break;
                case 'e5':
                    //FRONT,LEFT
                    phi = Math.PI * 0.5;
                    theta = -Math.PI * 0.25;
                    break;
                case 'e6':
                    //BACK,RIGHT
                    phi = Math.PI * 0.5;
                    theta = Math.PI * 0.75;
                    break;
                case 'e7':
                    //BACK,LEFT
                    phi = Math.PI * 0.5;
                    theta = -Math.PI * 0.75;
                    break;
                case 'e8':
                    //BACK,LEFT
                    phi = Math.PI * 0.25;
                    theta = Math.PI * 0.5;
                    break;
                case 'e9':
                    //TOP,RIGHT
                    phi = Math.PI * 0.25;
                    theta = -Math.PI * 0.5;
                    break;
                case 'e10':
                    //BOTTOM,RIGHT
                    phi = Math.PI * 0.75;
                    theta = Math.PI * 0.5;
                    break;

                case 'e11':
                    //BOTTOM,LEFT
                    phi = Math.PI * 0.75;
                    theta = -Math.PI * 0.5;
                    break;
                default:

            }


            this.controls.setPolarAngle(phi);
            //this.controls.setPhiDelta(phi);
            //this.controls.setThetaDelta(theta);
            this.controls.setAzimuthalAngle(theta);

            //this.controls.setPolarAngle(phi);
            //this.controls.setAzimuthalAngle(theta);

            if (this.props.onUpdateAngles) {

                this.props.onUpdateAngles(phi, theta);
            }
            //console.log('this.controls angles', (this.controls.getPolarAngle() / Math.PI).toFixed(4), (this.controls.getAzimuthalAngle() / Math.PI).toFixed(4));

        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // var canvas = this.refs.threeCanvas;

            renderer = null;
            scene = null;
            this.camera = null;
            cancelAnimationFrame(animation);
            window.removeEventListener('resize', this.updateDimensions);
            //canvas.removeEventListener('mousemove', this.onMouseMove);
            //canvas.removeEventListener('mouseup', this.handleClick);
            //this.controls.dispose();
        }
    }, {
        key: 'updateDimensions',
        value: function updateDimensions() {
            var _props = this.props,
                width = _props.width,
                height = _props.height;

            if (this.props.aspect) height = width / this.props.aspect;

            // var canvas = this.refs.threeCanvas;
            if(renderer !== null && this.camera !== null) {
                renderer.setSize(width, height);
                this.camera.aspect = width / height;
                this.camera.updateProjectionMatrix();
            }
        }
    }, {
        key: 'init',
        value: function init() {
            //var { width, height } = this.props;
            var width = this.props.width ? this.props.width : 100;
            var height = this.props.height ? this.props.height : 100;

            var canvas = this.refs.threeCanvas;

            if (this.props.aspect) height = width / this.props.aspect;

            // var marginTop = this.props.marginTop ? this.props.marginTop : 0;

            scene = new THREE.Scene();
            this.camera = new THREE.PerspectiveCamera(50, width / height, 0.1, 1000);

            var antialias = this.props.antialias ? this.props.antialias : false;

            renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: antialias, alpha: true });

            renderer.setSize(width, height);
            renderer.sortObjects = false;

            //var geometry = new THREE.SphereGeometry(3, 24, 24);
            // var material = new THREE.MeshBasicMaterial({ color: 0x00aaff, wireframe: false });
            //mainSphere = new THREE.Mesh(geometry, material);

            // var geometry = new THREE.BoxGeometry(3, 3, 3);
            // cube = new THREE.Mesh(geometry, material);
            //scene.add(cube);

            var gridXZ = new THREE.GridHelper(10, 20);
            gridXZ.name = 'grid';
            //scene.add(gridXZ);

            this.camera.position.z = this.props.zoom ? this.props.zoom : 8;
            this.cameraDistance = this.camera.position.z;

            //setup raycaster variables
            mouse = new THREE.Vector2();
            raycaster = new THREE.Raycaster();

            //canvas.addEventListener('mousedown', this.onClick, false)

            this._createCube();
            renderer.setPixelRatio(window.devicePixelRatio);

            /*controls*/

            if (this.updateAngles) {
                this.controls = new OrbitControls(this.camera, canvas, this.updateAngles);
            } else {
                this.controls = new OrbitControls(this.camera, canvas); //new OrbitControls(camera);
            }

            this.controls.enablePan = false;
            this.controls.enableZoom = false;
            this.controls.enableKeys = false;

            this.controls.setPolarAngle(Math.PI * 0.25);
            this.controls.setAzimuthalAngle(Math.PI * 0.25);
            // rotation in Y
            // controls.setAzimuthalAngle(theta);

            // rotation in X
            //controls.setPolarAngle(phi);
            var _this = this;

            this._render = function () {
                if(renderer !== null) {
                    animation = requestAnimationFrame(_this._render);
                    renderer.render(scene, _this.camera);

                    _this.camera.updateMatrixWorld();

                    raycaster.setFromCamera(mouse, _this.camera);
                    var intersects = raycaster.intersectObjects(controllers.children);

                    if (intersects.length > 0) {
                        if (_this.DEBUG) console.log('intersected', intersects);
                        if (INTERSECTED !== intersects[0].object) {
                            if (INTERSECTED) {
                                INTERSECTED.material.color.setHex(INTERSECTED.currentHex); //<--putback
                                INTERSECTED.material.visible = INTERSECTED.currVisible;
                                //this._createdOutlineCube(INTERSECTED);
                            }

                            INTERSECTED = intersects[0].object;
                            INTERSECTED.currentHex = INTERSECTED.material.color.getHex(); //<-putback

                            INTERSECTED.currVisible = INTERSECTED.material.visible;

                            //INTERSECTED.material.color.setHex(hoverColor);
                            INTERSECTED.material.visible = true;

                            if (_this.DEBUG) console.log('controller', INTERSECTED.name);
                            //INTERSECTED.visible = true;
                        }
                    } else {
                        if (INTERSECTED) {
                            INTERSECTED.material.color.setHex(INTERSECTED.currentHex); //<-putback
                            INTERSECTED.material.visible = INTERSECTED.currVisible;
                        }

                        INTERSECTED = null;

                        _this.controls.update();
                    }
                }
            };

            this._render();
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {

            event.preventDefault();
            var x = event.clientX / window.innerWidth * 2 - 1;
            var y = -(event.clientY / window.innerHeight) * 2 + 1;
            var dir = new THREE.Vector3(x, y, -1);
            dir.unproject(this.camera);

            raycaster = new THREE.Raycaster(this.camera.position, dir.sub(this.camera.position).normalize());

            // var intersects = raycaster.intersectObjects(scene.children);
            // if (intersects.length > 0) {
            //     var SELECTED = intersects[0].object;
            //     //scene.add(transformControl);
            //     //transformControl.attach(SELECTED);
            //     // var selectedNode = SELECTED;
            // } else {
            //     //transformControl.detach(SELECTED);
            // }
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(event) {
            this.mouseMoving = true;
            var canvas = this.refs.threeCanvas;
            var rect = canvas.getBoundingClientRect();
            mouse.x = (event.clientX - rect.left) / rect.width * 2 - 1;
            mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            if (this.DEBUG) console.log('mouse', mouse);
        }
    }, {
        key: '_createdOutlineCube',
        value: function _createdOutlineCube(object) {
            var box = new THREE.BoxHelper(object, 0x0022FF);
            object.add(box);
        }

        //Insert all 3D elements here

    }, {
        key: '_createCube',
        value: function _createCube() {
            var size = this.props.cubeSize ? this.props.cubeSize : 2;
            var axisHelper = new THREE.AxesHelper(size + 1);
            axisHelper.position.x = -size / 2 - 0.01;
            axisHelper.position.z = -size / 2 - 0.01;
            axisHelper.position.y = -size / 2 - 0.01;
            scene.add(axisHelper);

            var dir = new THREE.Vector3(1, 0, 0);

            //normalize the direction vector (convert to vector of length 1)
            dir.normalize();

            // var origin = new THREE.Vector3(-size / 2, -size / 2, -size / 2);
            // var length = size + 1;
            // var hex = 0xff0000;

            // var arrowHelper = new THREE.ArrowHelper(dir, origin, length, hex);
            //scene.add( arrowHelper );

            //var box = new THREE.BoxHelper( axisHelper, 0xffff00 );
            //scene.add( box );


            //Textures cube;
            //var texture_top = THREE.ImageUtils.loadTexture( './img/texture.jpg' );

            // texture.wrapS = THREE.RepeatWrapping;
            //texture.wrapT = THREE.RepeatWrapping;
            //texture.repeat.set(4, 4);

            var top = this.createTexturedPlane(size, texture_top);
            top.position.y = size / 2;
            top.rotation.x = -Math.PI / 2;
            scene.add(top);

            var front = this.createTexturedPlane(size, texture_front);
            front.position.z = size / 2;
            scene.add(front);

            var right = this.createTexturedPlane(size, texture_right);
            right.position.x = size / 2;
            right.rotation.y = Math.PI / 2;
            scene.add(right);

            var left = this.createTexturedPlane(size, texture_left);
            left.position.x = -size / 2;
            left.rotation.y = -Math.PI / 2;
            scene.add(left);

            var back = this.createTexturedPlane(size, texture_back);
            back.position.z = -size / 2;
            back.rotation.y = Math.PI;
            scene.add(back);

            var bottom = this.createTexturedPlane(size, texture_bottom);
            bottom.position.y = -size / 2;
            bottom.rotation.x = Math.PI / 2;
            scene.add(bottom);

            var shadow = this.createTexturedPlane(size + 1.5, texture_shadow, false);
            shadow.position.y = -size / 2 - 0.4;
            shadow.rotation.x = -Math.PI / 2;
            scene.add(shadow);

            controllers = new THREE.Object3D();

            //FRONT,TOP,RIGHT
            var c0 = this.createCornerCube(size, 1, 1, 1);
            c0.name = 'c0';
            controllers.add(c0);

            //FRONT,BOTTOM,RIGHT
            var c1 = this.createCornerCube(size, 1, -1, 1);
            c1.name = 'c1';
            controllers.add(c1);

            //FRONT,BOTTOM,lEFT
            var c2 = this.createCornerCube(size, -1, -1, 1);
            c2.name = 'c2';
            controllers.add(c2);

            //FRONT,TOP,lEFT
            var c3 = this.createCornerCube(size, -1, 1, 1);
            c3.name = 'c3';
            controllers.add(c3);

            //BACK,TOP,RIGHT
            var c4 = this.createCornerCube(size, 1, 1, -1);
            c4.name = 'c4';
            controllers.add(c4);

            //BACK,BOTTOM,RIGHT
            var c5 = this.createCornerCube(size, 1, -1, -1);
            c5.name = 'c5';
            controllers.add(c5);

            //BACK,BOTTOM,LEFT
            var c6 = this.createCornerCube(size, -1, -1, -1);
            c6.name = 'c6';
            controllers.add(c6);

            //BACK,TOP,LEFT
            var c7 = this.createCornerCube(size, -1, 1, -1);
            c7.name = 'c7';
            controllers.add(c7);

            //TOP,FRONT
            var e0 = this.createEdgeCube(size, 0, 1, 1);
            e0.name = 'e0';
            controllers.add(e0);

            //TOP,BOTTOM
            var e1 = this.createEdgeCube(size, 0, -1, 1);
            e1.name = 'e1';
            controllers.add(e1);

            //TOP,BACK
            var e2 = this.createEdgeCube(size, 0, 1, -1);
            e2.name = 'e2';
            controllers.add(e2);

            //BOTTOM,BACK
            var e3 = this.createEdgeCube(size, 0, -1, -1);
            e3.name = 'e3';
            controllers.add(e3);

            //FRONT,RIGHT
            var e4 = this.createEdgeCube(size, 1, 0, 1);
            e4.name = 'e4';
            controllers.add(e4);

            //FRONT,LEFT
            var e5 = this.createEdgeCube(size, -1, 0, 1);
            e5.name = 'e5';
            controllers.add(e5);

            //BACK,LEFT
            var e6 = this.createEdgeCube(size, 1, 0, -1);
            e6.name = 'e6';
            controllers.add(e6);

            //BACK,LEFT
            var e7 = this.createEdgeCube(size, -1, 0, -1);
            e7.name = 'e7';
            controllers.add(e7);

            //BACK,LEFT
            var e8 = this.createEdgeCube(size, 1, 1, 0);
            e8.name = 'e8';
            controllers.add(e8);

            //TOP,RIGHT
            var e9 = this.createEdgeCube(size, -1, 1, 0);
            e9.name = 'e9';
            controllers.add(e9);

            //BOTTOM,RIGHT
            var e10 = this.createEdgeCube(size, 1, -1, 0);
            e10.name = 'e10';
            controllers.add(e10);

            //BOTTOM,LEFT
            var e11 = this.createEdgeCube(size, -1, -1, 0);
            e11.name = 'e11';
            controllers.add(e11);

            //RIGHT
            var f0 = this.createFaceCube(size, 1, 0, 0);
            f0.name = 'f0';
            controllers.add(f0);

            //TOP
            var f1 = this.createFaceCube(size, 0, 1, 0);
            f1.name = 'f1';
            controllers.add(f1);

            //FRONT
            var f2 = this.createFaceCube(size, 0, 0, 1);
            f2.name = 'f2';
            controllers.add(f2);

            //LEFT
            var f3 = this.createFaceCube(size, -1, 0, 0);
            f3.name = 'f3';
            controllers.add(f3);

            //BOTTOM
            var f4 = this.createFaceCube(size, 0, -1, 0);
            f4.name = 'f4';
            controllers.add(f4);

            //BACK
            var f5 = this.createFaceCube(size, 0, 0, -1);
            f5.name = 'f5';
            controllers.add(f5);

            scene.add(controllers);
        }
    }, {
        key: 'createFaceCube',
        value: function createFaceCube(size, x, y, z) {
            var c_cube = size / 4; //corner cubes
            var sizex = c_cube;
            var sizey = c_cube;
            var sizez = c_cube;

            if (x === 0) {
                sizey = size / 2;
                sizez = size / 2;
            }
            if (y === 0) {
                sizex = size / 2;
                sizez = size / 2;
            }
            if (z === 0) {
                sizex = size / 2;
                sizey = size / 2;
            }

            var _x = x * 1.01;
            var _y = y * 1.01;
            var _z = z * 1.01;

            /*
            var material = new THREE.ShaderMaterial({
                vertexShader: vertexShader,
                fragmentShader: fragmentShader,
                visible:true
            });
             //material.transparent = true;
            */

            var material = new THREE.MeshBasicMaterial({ color: this.hoverColor, transparent: true, opacity: 0.5, visible: false }); //change to false later
            var geometry = new THREE.BoxGeometry(sizex, sizey, sizez);

            var edgeCube = new THREE.Mesh(geometry, material);
            //this._createdOutlineCube(edgeCube);
            if (x > 0) {
                edgeCube.position.x = size / 2 * _x - sizex / 2;
            } else {
                edgeCube.position.x = x === 0 ? 0 : size / 2 * _x + sizex / 2;
            }

            if (y > 0) {
                edgeCube.position.y = size / 2 * _y - sizey / 2;
            } else {
                edgeCube.position.y = y === 0 ? 0 : size / 2 * _y + sizey / 2;
            }

            if (z > 0) {
                edgeCube.position.z = size / 2 * _z - sizez / 2;
            } else {
                edgeCube.position.z = z === 0 ? 0 : size / 2 * _z + sizez / 2;
            }

            return edgeCube;
        }
    }, {
        key: 'createEdgeCube',
        value: function createEdgeCube(size, x, y, z) {

            var c_cube = size / 4; //corner cubes
            var sizex = c_cube;
            var sizey = c_cube;
            var sizez = c_cube;

            if (x === 0) {
                sizex = size / 2;
            }
            if (y === 0) {
                sizey = size / 2;
            }
            if (z === 0) {
                sizez = size / 2;
            }
            var _x = x * 1.01;
            var _y = y * 1.01;
            var _z = z * 1.01;

            //*creating small cubs
            var material = new THREE.MeshBasicMaterial({ color: this.hoverColor, transparent: true, opacity: 0.5, visible: false, side: THREE.DoubleSide }); //change to false later
            var geometry = new THREE.BoxGeometry(sizex, sizey, sizez);
            //this._createdOutlineCube(edgeCube);
            var edgeCube = new THREE.Mesh(geometry, material);
            if (x > 0) {
                edgeCube.position.x = size / 2 * _x - sizex / 2;
            } else {
                edgeCube.position.x = x === 0 ? 0 : size / 2 * _x + sizex / 2;
            }

            if (y > 0) {
                edgeCube.position.y = size / 2 * _y - sizey / 2;
            } else {
                edgeCube.position.y = y === 0 ? 0 : size / 2 * _y + sizey / 2;
            }

            if (z > 0) {
                edgeCube.position.z = size / 2 * _z - sizez / 2;
            } else {
                edgeCube.position.z = z === 0 ? 0 : size / 2 * _z + sizez / 2;
            }

            return edgeCube;
        }
    }, {
        key: 'createCornerCube',
        value: function createCornerCube(size, x, y, z) {
            var _x = x * 1.01;
            var _y = y * 1.01;
            var _z = z * 1.01;
            var c_cube = size / 4; //corner cubes
            //*creating small cubs
            var material = new THREE.MeshBasicMaterial({ color: this.hoverColor, transparent: true, opacity: 0.5, visible: false });
            var geometry = new THREE.BoxGeometry(c_cube, c_cube, c_cube);

            var cornerCube = new THREE.Mesh(geometry, material);
            if (x > 0) {
                cornerCube.position.x = size / 2 * _x - c_cube / 2;
            } else {
                cornerCube.position.x = size / 2 * _x + c_cube / 2;
            }
            if (y > 0) {
                cornerCube.position.y = size / 2 * _y - c_cube / 2;
            } else {
                cornerCube.position.y = size / 2 * _y + c_cube / 2;
            }
            if (z > 0) {
                cornerCube.position.z = size / 2 * _z - c_cube / 2;
            } else {
                cornerCube.position.z = size / 2 * _z + c_cube / 2;
            }
            return cornerCube;
        }
    }, {
        key: 'createTexturedPlane',
        value: function createTexturedPlane(size, texturePath) {
            var side = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : THREE.DoubleSide;

            var texture = new THREE.TextureLoader().load(texturePath);
            var material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, visible: true, side: side });
            var geometry = new THREE.PlaneGeometry(size, size);
            var mesh = new THREE.Mesh(geometry, material);
            return mesh;
        }
    }, {
        key: 'hoverHomeOn',
        value: function hoverHomeOn() {
            this.setState({ icon_home: icon_home_hover });
            //this.icon_home = icon_home_hover;
        }
    }, {
        key: 'hoverHomeOff',
        value: function hoverHomeOff() {
            this.setState({ icon_home: icon_home });
        }
    }, {
        key: 'clickHome',
        value: function clickHome() {
            this.controls.setPolarAngle(Math.PI * 0.25);
            this.controls.setAzimuthalAngle(Math.PI * 0.25);
            //this.controls.reset();
            if (this.props.onUpdateAngles) {
                this.props.onUpdateAngles(Math.PI * 0.25, Math.PI * 0.25);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            // var width = this.props.width ? this.props.width : 100;
            // var height = this.props.height ? this.props.height : 100;

            return _react2.default.createElement(
                'div',
                { className: 'cube-view-container' },
                _react2.default.createElement('img', { src: this.state.icon_home,
                    className: 'button-home',
                    onMouseOver: this.hoverHomeOn,
                    onMouseOut: this.hoverHomeOff,
                    onClick: this.clickHome

                }),
                _react2.default.createElement(
                    'canvas',
                    { ref: 'threeCanvas' },
                    ' '
                )
            );
        }
    }]);

    return CubeView;
}(_react.Component);

//const exported = sizeMe({ monitorHeight: true, refreshRate: 80, monitorPosition: true })(CubeView);
//exported.setAngles = CubeView.setAngles;

//export default exported;


exports.default = CubeView;
//export default sizeMe({ monitorHeight: true, refreshRate: 80, monitorPosition: true })(CubeView);